import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  ActionMaster,
  ActionMasterList,
  ActionPayload,
} from "@/utils/types/actionMasters";
const basePath = "/workflow/actions";

class WorkflowActionService {
  getAllActionMasters = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<ActionMasterList> => {
    return await get<ActionMasterList>(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getActionMasterById = async (id: string): Promise<ActionMaster> => {
    if (!id) {
      throwError("ID is required", "WorkflowActionService");
    }
    return await get<ActionMaster>(`${basePath}/${id}/`);
  };

  createActionMaster = async (payload: ActionPayload): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "WorkflowActionService");
    }
    return await post(`${basePath}/`, payload);
  };

  updateActionMaster = async (
    id: string,
    payload: ActionPayload
  ): Promise<any> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "WorkflowActionService");
    }
    return await put(`${basePath}/${id}/`, payload);
  };

  deleteActionMaster = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "WorkflowActionService");
    }
    return await del(`${basePath}/${id}/`);
  };
}

const instance = new WorkflowActionService();
export default instance;
